export const ciColors = {
  black: '#222233',
  white: '#ffffff',
  lightGrey: '#e5e5f5',
  mediumGrey: '#9999aa',
  darkGrey: '#555566',
  rose: '#f3d3fb',
  blue: '#003480',
  green: '#00b38a',
};

export const appColors = {
  fontPrimary: ciColors.black,
  fontSecondary: ciColors.mediumGrey,
  backgroundPrimary: ciColors.white,
  backgroundSecondary: ciColors.lightGrey,
  navbarBackground: ciColors.blue,
  navbarFont: ciColors.white,
  modalFont: ciColors.blue,
  modalBackground: ciColors.rose,
  buttonFont: ciColors.blue,
  buttonBackground: ciColors.rose,
  tagNeutral: ciColors.blue,
  tagSuccess: ciColors.green,
  tagFail: ciColors.darkGrey,
  border: ciColors.mediumGrey,
  outline: ciColors.blue,
  shadow: ciColors.blue,
};
